import { render } from "./addressDisplay.vue?vue&type=template&id=647fd8fa&scoped=true"
import script from "./addressDisplay.vue?vue&type=script&lang=js"
export * from "./addressDisplay.vue?vue&type=script&lang=js"

import "./addressDisplay.vue?vue&type=style&index=0&id=647fd8fa&scoped=true&lang=less"

import exportComponent from "D:\\新建文件夹\\资料\\PC享赫生活\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647fd8fa"]])

export default __exports__